import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { environment } from 'src/environments/environment';
import { DemandasMonitoramentoService } from '../services/demandas-monitoramento.service';
import { NavigationService } from '../services/navigation.service';

@Component({
  selector: 'app-demandas-monitoramento-mensagens',
  templateUrl: './demandas-monitoramento-mensagens.component.html',
  styleUrls: ['./demandas-monitoramento-mensagens.component.scss']
})
export class DemandasMonitoramentoMensagensComponent extends BaseFormComponent<any> implements OnInit {

  idProjeto: number;
  infoDemanda: any;
  serverUrl: string = environment.serverUrl;
  link: string;
  linkLabel: string;

  constructor(
    private myService: DemandasMonitoramentoService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loading();
    this.infoDemanda = this.activatedRoute.snapshot.data['infoDemanda'];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = this.fb.group({
      message: ['', Validators.required],
    });
  }

  reloadDemanda() {
    this.addSub(
      this.myService.getById(this.infoDemanda.id).subscribe({
        next: (res) => {
          this.form.reset();
          this.infoDemanda = res;
        }
      })
    )
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.createMessage(this.infoDemanda.id, this.form.value).subscribe({
          next: (res) => {
            this.reloadDemanda();
            this.msgSuccess('Mensagem salva com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  concluir() {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.concluir(this.infoDemanda.id, this.form.value).subscribe({
          next: (res) => {
            this.reloadDemanda();
            this.msgSuccess('Demanda concluída com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  transferir() {
    if (this.form.valid) {
      this.loading();
      this.addSub(
        this.myService.transferir(this.infoDemanda.id, this.form.value).subscribe({
          next: (res) => {
            this.reloadDemanda();
            this.msgSuccess('Demanda transferida com sucesso!');
            this.loaded();
          },
          error: (error) => {
            this.msgError(error?.error?.message);
            this.loaded();
          },
        })
      );
    } else {
      this.markAsDirty();
    }
  }

  voltar() {
    this.navigation.back(['projetos', 'demandas-monitoramento']);
  }

  cadastro() {
    this.router.navigate(['projetos', 'demandas-monitoramento', this.infoDemanda.id]);
  }
}
